var render = function render(){var _vm=this,_c=_vm._self._c;return _c('finished-join-request-data-table',{attrs:{"allfinishedparticipants":_vm.allfinishedparticipants}})
}
var staticRenderFns = []

export { render, staticRenderFns }